import { useEffect } from "react";
import { useLocation } from "react-router-dom";

declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

export function GoogleAnalytics() {
  const location = useLocation();

  // Track page views on route change
  useEffect(() => {
    if (!window.gtag) return;

    window.gtag("config", "G-GQHP5H6RPT", {
      page_path: location.pathname + location.search,
    });
  }, [location]);

  return null;
}
